'use client'
import { shareInfoTypes } from '@/app/livebroadcast/_config'
import { useTranslations } from 'next-intl'
import React, { useEffect } from 'react'

declare global {
    interface Window { Kakao?: any }
}

type Props = {
    url?: string
    title?: string
    text?: string
    imageUrl?: string
}

export default function ShareSheet({
    url = typeof window !== 'undefined' ? window.location.href : '',
    title = '제목',
    description = '설명',
    imageUrl = '',
}: shareInfoTypes) {

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    // 카카오 SDK 로드/초기화 (optional)
    useEffect(() => {
        if (typeof window === 'undefined') return
        if (window.Kakao) return
        const s = document.createElement('script')
        s.src = 'https://developers.kakao.com/sdk/js/kakao.min.js'
        s.async = true
        s.onload = () => {
            try {
                const K = window.Kakao
                if (K && !K.isInitialized?.()) {
                    K.init('d0f4ae6b7ef8b43f7ecf81d240d17442') // <-- 카카오 JavaScript 키
                }
            } catch (e) { console.warn(e) }
        }
        document.head.appendChild(s)
    }, [])

    // 1) Web Share API
    async function useWebShare() {
        if ((navigator as any).share) {
            try {
                await (navigator as any).share({ title, description, url })
                return true
            } catch (e) {
                // 사용자가 취소했을 수도 있음
                return false
            }
        }
        return false
    }

    // 2) 앱별 공유 함수들 (폴백)
    function shareKakao() {
        const contentUrl = safeImageUrl(imageUrl)
        // console.log("***", contentUrl) 
        try {
            const K = window.Kakao
            if (!K || !K.Link) {
                // SDK 없으면 카카오 웹 공유 페이지로 fallback (간단)
                window.open(`https://sharer.kakao.com/talk/friends/picker/link?url=${encodeURIComponent(url)}`, '_blank')
                return
            }
            K.Link.sendDefault({
                objectType: 'feed',
                content: {
                    title,
                    description: description,
                    imageUrl: contentUrl,
                    link: { mobileWebUrl: url, webUrl: url },
                },
            })
        } catch (e) { console.warn(e) }
    }
    const safeImageUrl = (img?: string) => {
        if (!img) return "";             // 빈값이면 undefined로
        if (typeof img !== 'string') return "";
        if (!/^https?:\/\//.test(img)) return ""; // 절대 URL 검사
        return img;
    }

    function shareWhatsApp() {
        const textParam = encodeURIComponent(`${title}\n${url}`)
        const web = `https://wa.me/?text=${textParam}`
        window.open(web, '_blank')
    }

    function shareFacebook() {
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
        window.open(shareUrl, '_blank', 'noopener,noreferrer')
    }

    function shareTwitter() {
        const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`
        window.open(shareUrl, '_blank')
    }

    function shareLine() {
        const shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`
        window.open(shareUrl, '_blank')
    }

    async function onlyWebShare(){
        await useWebShare()
    }

    async function handleKakaoClick() {
        // 우선 WebShare(네이티브 시트) 시도 -> 아니면 카카오 SDK
        const used = await useWebShare()
        if (!used) shareKakao()
    }

    async function handleOtherClick(fn: () => void) {
        const used = await useWebShare()
        if (!used) fn()
    }

    async function copyLink() {
        try {
            await navigator.clipboard.writeText(url)
            alert(a("CopiedLink"))
        } catch {
            prompt(a("CopiedLinkPrompt"), url)
        }
    }

    return (
        <div style={{ padding: 16, width: 360 }}>
            <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 8 }}>
                <button onClick={handleKakaoClick}>{t("카카오톡")}</button>
                <button onClick={() => handleOtherClick(shareFacebook)}>Facebook</button>
                <button onClick={() => handleOtherClick(shareTwitter)}>X</button>
                <button onClick={() => handleOtherClick(shareLine)}>Line</button>
            </div>

            <div style={{ marginTop: 12 }}>
                <input readOnly value={url} style={{ width: '100%' }} />
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <button onClick={copyLink}>{t("복사")}</button>
                    <button onClick={() => handleOtherClick(() => window.open(`sms:?body=${encodeURIComponent(url)}`))}>SMS</button>
                </div>
            </div>
        </div>
    )
}